import React from 'react';
import { cn } from '../cn';
import { Button } from '../Button';
import { IconClose } from '../Icons';

type Props = {
  /**
   * Function that is called when the reset button is clicked.
   */
  onReset?: () => void,
}

export default function TextfieldResetButton({ onReset }: Props): JSX.Element {
  return (
    <Button
      unstyled
      onPress={onReset}
      className={cn([
        'p-1 size-6 flex items-center justify-center',
        'bg-transparent hover:bg-neutral-200 active:bg-neutral-300',
        'rounded-full',
      ])}
    >
      <IconClose className='size-4'/>
    </Button>
  );
}
